import { render, staticRenderFns } from "./SputumCulture.vue?vue&type=template&id=1d406796&scoped=true&"
import script from "./SputumCulture.vue?vue&type=script&lang=js&"
export * from "./SputumCulture.vue?vue&type=script&lang=js&"
import style0 from "./SputumCulture.vue?vue&type=style&index=0&id=1d406796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d406796",
  null
  
)

export default component.exports